<template>
  <section class="hbox stretch">
    <div class="content-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>营销</el-breadcrumb-item>
        <el-breadcrumb-item>抢购</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content-main">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="AddFlashSales" >新增</el-button>
        </el-form-item>         
        <el-form-item >
          <el-input  placeholder="抢购名称" v-model="name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="Search" >查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="flashSales" style="width: 100%">
        <el-table-column  prop="Title" fixed="left" label="名称"> </el-table-column>
        <el-table-column  prop="BusinessName"  label="所属商家"> </el-table-column>
        <el-table-column  prop="IndustryName"  label="行业"> </el-table-column>
        <el-table-column  prop="FlashPrice"  label="抢购价"> </el-table-column>
        <el-table-column  prop="TotalCount"  label="总数量"> </el-table-column>
        <el-table-column  prop="SoldCount"  label="已售数量" ></el-table-column>
        <el-table-column  prop="LimitCount"  label="单人限购" ></el-table-column>
        <el-table-column  prop="BeginTime"  label="开始时间" :formatter="dateFormat"> </el-table-column>
        <el-table-column  prop="EndTime"  label="结束时间" :formatter="dateFormat"> </el-table-column>
        <el-table-column  prop="PutOnShelves"  label="状态" > 
          <template slot-scope="scope">                    
            <p v-if="scope.row.PutOnShelves=='true'">上架</p>
            <p v-if="scope.row.PutOnShelves=='false'">下架</p>         
          </template>
        </el-table-column>
        <el-table-column  fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click.native.prevent="editFlashSales(scope.row.Id)" type="text" size="small">
              编辑
            </el-button>
          <el-button  @click="DeleteRow(scope.row.Id)" type="text" size="small">&nbsp; 删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>   
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {
        name:'',
        pageIndex:1,
        pagesize:10,
        totalCount:10,
        totalPage:1,
        sort:' CreateTime desc ',
        flashSales:[]
      }
    },
    computed:{
    },
    mounted(){
      this.FlashSalesQuery();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.FlashSalesQuery();
      },
      AddFlashSales:function(){
        this.$router.push({
          name:'flashSaleInfo',
          params:{
            Id:''
          }
        })
      },
      FlashSalesQuery:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/FlashSale/index',
          params:{
            name : that.name,
            pageIndex : that.pageIndex,
            pagesize : that.pagesize,
            sort : that.sort
          }
        }).then(function (resp) {
          that.totalCount = resp.data.totalCount
          that.totalPage = resp.data.totalPage
          that.flashSales = resp.data.flashSales
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      editFlashSales(id){
        this.$router.push({
          name:'flashSaleInfo',
          params:{
            Id:id
          }
        })
      },
      DeleteRow(id) {
        this.$confirm('确定要删除该抢购吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/FlashSale/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetUserRoleData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>